'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isClientSide = typeof window !== 'undefined';
var preInitCallbackQueueName = '__icookFbCallbackQueue_preInit';
var postInitCallbackQueueName = '__icookFbCallbackQueue_postInit';

var preInitCallbackQueue = isClientSide && window[preInitCallbackQueueName] || [];

var postInitCallbackQueue = isClientSide && window[postInitCallbackQueueName] || [];

var appId = {
  development: '1551057831575704',
  production: '273393289342171'
};

var appIdInUse = isClientSide && (/.test$/.test(window.location.origin) ? appId.development : appId.production) || '';

var fbAsyncInitIsDone = false;

if (isClientSide) {
  // Expose callback queues for other apps to register callback with the code below
  /* eslint-disable max-len */
  // (window.__icookFbCallbackQueue_preInit = window.__icookFbCallbackQueue_preInit || []).push(function () {});
  // (window.__icookFbCallbackQueue_postInit = window.__icookFbCallbackQueue_postInit || []).push(function () {});
  /* eslint-enable max-len */
  window[preInitCallbackQueueName] = preInitCallbackQueue;
  window[postInitCallbackQueueName] = postInitCallbackQueue;

  window.fbAsyncInit = function fbAsyncInit() {
    Object.defineProperty(preInitCallbackQueue, 'push', {
      value: function value() {
        throw new Error('Do not push callback into ' + preInitCallbackQueueName + ' after fbAsyncInit is called.');
      }
    });
    while (preInitCallbackQueue.length) {
      preInitCallbackQueue.shift()();
    }

    window.FB.init({
      appId: appIdInUse,
      cookie: true,
      xfbml: true,
      version: 'v20.0'
    });

    fbAsyncInitIsDone = true;
    Object.defineProperty(postInitCallbackQueue, 'push', {
      value: function value(fn) {
        return fn();
      }
    });
    while (postInitCallbackQueue.length) {
      postInitCallbackQueue.shift()();
    }
  };

  (function loadFacebookSDK(d, s, id) {
    var fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    var js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/zh_TW/sdk.js';
    if (fjs) {
      fjs.parentNode.insertBefore(js, fjs);
    } else {
      d.body.appendChild(js);
    }
  })(window.document, 'script', 'facebook-jssdk');
}

var isInitialized = function isInitialized() {
  return fbAsyncInitIsDone;
};
var getAppIdInUse = function getAppIdInUse() {
  return appIdInUse;
};
var beforeInitialized = function beforeInitialized(callback) {
  return preInitCallbackQueue.push(callback);
};
var ensureInitialized = function ensureInitialized(callback) {
  return postInitCallbackQueue.push(callback);
};

exports.appId = appId;
exports.getAppIdInUse = getAppIdInUse;
exports.isInitialized = isInitialized;
exports.beforeInitialized = beforeInitialized;
exports.ensureInitialized = ensureInitialized;
exports.preInitCallbackQueueName = preInitCallbackQueueName;
exports.postInitCallbackQueueName = postInitCallbackQueueName;
